// メニュー項目の型定義
export interface MenuItem {
  path: string;
  label: string;
  icon?: string; // 将来的にアイコンを追加する場合
}

// メニュー項目の配列（ここを編集するだけで簡単に追加・削除可能）
export const menuItems: MenuItem[] = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About' },
  { path: '/gallery', label: 'Gallery' },
  { path: '/character' , label: 'Character'},
  { path: '/software', label:'Software'},
  { path: '/works', label: 'Works' },
  { path: '/links', label: 'Links' },

  // 新しいページを追加する場合は、ここに追加するだけ
  // { path: '/works', label: 'Works' },
  // { path: '/contact', label: 'Contact' },
];
